import { apiClient } from './api'

export interface TimelineTask {
  id: number
  title: string
  status: string
  assignee_id: number | null
  milestone_id: number | null
  start: string | null
  end: string | null
  scheduled: boolean
  critical: boolean
  slack_days: number | null
}

export interface TimelineMilestone {
  id: number
  name: string
  due_date: string | null
  status: string
}

export interface TaskDependency {
  id: number
  predecessor_id: number
  successor_id: number
  dependency_type: string
  lag_days: number
}

export interface ScheduleConflict {
  predecessor_id: number
  successor_id: number
  successor_start: string
  earliest_allowed_start: string
  days_early: number
}

export interface ProjectTimeline {
  project_id: number
  range_start: string | null
  range_end: string | null
  project_finish: string | null
  tasks: TimelineTask[]
  milestones: TimelineMilestone[]
  dependencies: TaskDependency[]
  conflicts: ScheduleConflict[]
}

export const timelineService = {
  async get(projectId: number): Promise<ProjectTimeline> {
    const { data } = await apiClient.get<ProjectTimeline>(`/api/v1/projects/${projectId}/timeline`)
    return data
  },
  async addDependency(projectId: number, predecessorId: number, successorId: number, lagDays = 0): Promise<TaskDependency> {
    const { data } = await apiClient.post<TaskDependency>(`/api/v1/projects/${projectId}/dependencies`, {
      predecessor_id: predecessorId,
      successor_id: successorId,
      lag_days: lagDays,
    })
    return data
  },
  async removeDependency(projectId: number, dependencyId: number): Promise<void> {
    await apiClient.delete(`/api/v1/projects/${projectId}/dependencies/${dependencyId}`)
  },
}

/** Whole days between two ISO dates (b - a). */
export function daysBetween(a: string, b: string): number {
  const ms = Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)
  return Math.round(ms / 86_400_000)
}

export function addDays(iso: string, days: number): string {
  const d = new Date(`${iso}T00:00:00Z`)
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}
